export const SeasonalColumns = [
  {
    Header: "Offer Name",
    accessor: "offer_name",
  },
  {
    Header: "Offer Type",
    accessor: "offer_type",
  },
  {
    Header: "Room Type",
    accessor: "room_type",
  },
  {
    Header: "Valid From",
    accessor: "valid_date_from",
  },
  {
    Header: "Valid To",
    accessor: "valid_date_to",
  },
  {
    Header: "Discount (%)",
    accessor: "discount_value",
    disableSortBy: true,
  },
  {
    Header: "Actions",
    accessor: "actions",
    disableSortBy: true,
  },
];

export const SeasonalData = [
  {
    offer_name: "Summer Splash",
    room_type: "Deluxe",
    offer_type: "Seasonal",
    valid_date_from: "2025-06-01",
    valid_date_to: "2025-07-31",
    discount_value: "20%",
  },
  {
    offer_name: "Winter Warmth",
    room_type: "Studio",
    offer_type: "Seasonal",
    valid_date_from: "2025-12-01",
    valid_date_to: "2026-01-15",
    discount_value: "₹500",
  },
  {
    offer_name: "King’s Delight",
    room_type: "King",
    offer_type: "Seasonal",
    valid_date_from: "2025-08-10",
    valid_date_to: "2025-09-30",
    discount_value: "15%",
  },
  {
    offer_name: "Queen’s Treat",
    room_type: "Queen",
    offer_type: "Seasonal",
    valid_date_from: "2025-11-01",
    valid_date_to: "2025-11-30",
    discount_value: "₹750",
  },
  {
    offer_name: "Weekend Bonanza",
    room_type: "Queen",
    offer_type: "Weekend",
    valid_date_from: "2025-05-10",
    valid_date_to: "2025-05-12",
    discount_value: "10%",
  },
  {
    offer_name: "Mid-Year Sale",
    room_type: "Queen",
    offer_type: "Seasonal",
    valid_date_from: "2025-07-01",
    valid_date_to: "2025-07-07",
    discount_value: "₹600",
  },
  {
    offer_name: "Holiday Special",
    room_type: "Queen",
    offer_type: "Weekend",
    valid_date_from: "2025-12-24",
    valid_date_to: "2026-01-01",
    discount_value: "25%",
  },
  {
    offer_name: "Spring Fest",
    room_type: "Queen",
    offer_type: "Seasonal",
    valid_date_from: "2025-03-20",
    valid_date_to: "2025-04-10",
    discount_value: "₹400",
  },
  {
    offer_name: "Festival Discount",
    room_type: "Queen",
    offer_type: "Seasonal",
    valid_date_from: "2025-10-15",
    valid_date_to: "2025-10-25",
    discount_value: "18%",
  },
  {
    offer_name: "Monsoon Magic",
    room_type: "Queen",
    offer_type: "Seasonal",
    valid_date_from: "2025-07-15",
    valid_date_to: "2025-08-15",
    discount_value: "₹300",
  },
];
